// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type CmsIntegrationsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  connected?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type CmsIntegrationsForSiteQuery = (
  { __typename?: 'Query' }
  & { cmsIntegrationsForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CmsProvider' }
    & Pick<Types.CmsProvider, 'id' | 'name' | 'formattedName' | 'logoUrl' | 'details' | 'description' | 'connected'>
    & { features?: Types.Maybe<(
      { __typename?: 'IntegrationFeatures' }
      & Pick<Types.IntegrationFeatures, 'envVars' | 'webhooks' | 'extension'>
    )> }
  )>>> }
);

export type SetSiteCmsIntegrationMutationVariables = Types.Exact<{
  config: Types.Scalars['JSON'];
  siteId: Types.Scalars['UUID'];
  vendor: Types.CmsVendor;
}>;


export type SetSiteCmsIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { setSiteCMSIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);

export type InstallCosmicCmsIntegrationMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  authToken: Types.Scalars['String'];
  provision?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type InstallCosmicCmsIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { installCosmicCmsIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type InstallShopifyCmsIntegrationMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  password: Types.Scalars['String'];
  provision?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type InstallShopifyCmsIntegrationMutation = (
  { __typename?: 'Mutation' }
  & { installShopifyCmsIntegration?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type AvailableContentfulOrganizationsForUserQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type AvailableContentfulOrganizationsForUserQuery = (
  { __typename?: 'Query' }
  & { availableContentfulOrganizationsForUser?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'ContentfulOrganization' }
    & Pick<Types.ContentfulOrganization, 'id' | 'name' | 'selected' | 'selectedSpace'>
    & { spaces?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ContentfulSpace' }
      & Pick<Types.ContentfulSpace, 'id' | 'name' | 'selected'>
    )>>> }
  )>>> }
);

export type CosmicCmsBucketsForIntegrationQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type CosmicCmsBucketsForIntegrationQuery = (
  { __typename?: 'Query' }
  & { cosmicCMSBucketsForIntegration?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CosmicCmsBucket' }
    & Pick<Types.CosmicCmsBucket, 'id' | 'name' | 'selected'>
  )>>> }
);

export type DatoCmsProjectsForIntegrationQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type DatoCmsProjectsForIntegrationQuery = (
  { __typename?: 'Query' }
  & { datoCMSProjectsForIntegration?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'DatoCmsProject' }
    & Pick<Types.DatoCmsProject, 'id' | 'name' | 'selected'>
  )>>> }
);

export type SanityCmsProjectsForIntegrationQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type SanityCmsProjectsForIntegrationQuery = (
  { __typename?: 'Query' }
  & { sanityCMSProjectsForIntegration?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'SanityProject' }
    & Pick<Types.SanityProject, 'id' | 'name' | 'selected' | 'selectedDataset'>
  )>>> }
);

export type SanityCmsDatasetsForIntegrationQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  projectId: Types.Scalars['String'];
}>;


export type SanityCmsDatasetsForIntegrationQuery = (
  { __typename?: 'Query' }
  & { sanityCMSDatasetsForIntegration?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'SanityDataset' }
    & Pick<Types.SanityDataset, 'name' | 'aclMode'>
  )>>> }
);

export type DatoCmsAddedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type DatoCmsAddedSubscription = (
  { __typename?: 'Subscription' }
  & Pick<Types.Subscription, 'datoCmsIntegrationAdded'>
);

export type ContentfulAddedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ContentfulAddedSubscription = (
  { __typename?: 'Subscription' }
  & Pick<Types.Subscription, 'contentfulIntegrationAdded'>
);

export type SanityAddedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type SanityAddedSubscription = (
  { __typename?: 'Subscription' }
  & Pick<Types.Subscription, 'sanityIntegrationAdded'>
);


export const CmsIntegrationsForSiteDocument = gql`
    query CmsIntegrationsForSite($siteId: UUID!, $connected: Boolean) {
  cmsIntegrationsForSite(siteId: $siteId, connected: $connected) {
    id
    name
    formattedName
    logoUrl
    details
    description
    connected
    features {
      envVars
      webhooks
      extension
    }
  }
}
    `;

/**
 * __useCmsIntegrationsForSiteQuery__
 *
 * To run a query within a React component, call `useCmsIntegrationsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsIntegrationsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsIntegrationsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      connected: // value for 'connected'
 *   },
 * });
 */
export function useCmsIntegrationsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>(CmsIntegrationsForSiteDocument, baseOptions);
      }
export function useCmsIntegrationsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>(CmsIntegrationsForSiteDocument, baseOptions);
        }
export type CmsIntegrationsForSiteQueryHookResult = ReturnType<typeof useCmsIntegrationsForSiteQuery>;
export type CmsIntegrationsForSiteLazyQueryHookResult = ReturnType<typeof useCmsIntegrationsForSiteLazyQuery>;
export type CmsIntegrationsForSiteQueryResult = ApolloReactCommon.QueryResult<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>;
export const SetSiteCmsIntegrationDocument = gql`
    mutation SetSiteCMSIntegration($config: JSON!, $siteId: UUID!, $vendor: CmsVendor!) {
  setSiteCMSIntegration(config: $config, siteId: $siteId, vendor: $vendor) {
    success
    message
    errorType
  }
}
    `;
export type SetSiteCmsIntegrationMutationFn = ApolloReactCommon.MutationFunction<SetSiteCmsIntegrationMutation, SetSiteCmsIntegrationMutationVariables>;

/**
 * __useSetSiteCmsIntegrationMutation__
 *
 * To run a mutation, you first call `useSetSiteCmsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSiteCmsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSiteCmsIntegrationMutation, { data, loading, error }] = useSetSiteCmsIntegrationMutation({
 *   variables: {
 *      config: // value for 'config'
 *      siteId: // value for 'siteId'
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useSetSiteCmsIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetSiteCmsIntegrationMutation, SetSiteCmsIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<SetSiteCmsIntegrationMutation, SetSiteCmsIntegrationMutationVariables>(SetSiteCmsIntegrationDocument, baseOptions);
      }
export type SetSiteCmsIntegrationMutationHookResult = ReturnType<typeof useSetSiteCmsIntegrationMutation>;
export type SetSiteCmsIntegrationMutationResult = ApolloReactCommon.MutationResult<SetSiteCmsIntegrationMutation>;
export type SetSiteCmsIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<SetSiteCmsIntegrationMutation, SetSiteCmsIntegrationMutationVariables>;
export const InstallCosmicCmsIntegrationDocument = gql`
    mutation installCosmicCmsIntegration($siteId: UUID!, $authToken: String!, $provision: Boolean) {
  installCosmicCmsIntegration(
    siteId: $siteId
    authToken: $authToken
    provision: $provision
  ) {
    success
    message
  }
}
    `;
export type InstallCosmicCmsIntegrationMutationFn = ApolloReactCommon.MutationFunction<InstallCosmicCmsIntegrationMutation, InstallCosmicCmsIntegrationMutationVariables>;

/**
 * __useInstallCosmicCmsIntegrationMutation__
 *
 * To run a mutation, you first call `useInstallCosmicCmsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallCosmicCmsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installCosmicCmsIntegrationMutation, { data, loading, error }] = useInstallCosmicCmsIntegrationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      authToken: // value for 'authToken'
 *      provision: // value for 'provision'
 *   },
 * });
 */
export function useInstallCosmicCmsIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InstallCosmicCmsIntegrationMutation, InstallCosmicCmsIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<InstallCosmicCmsIntegrationMutation, InstallCosmicCmsIntegrationMutationVariables>(InstallCosmicCmsIntegrationDocument, baseOptions);
      }
export type InstallCosmicCmsIntegrationMutationHookResult = ReturnType<typeof useInstallCosmicCmsIntegrationMutation>;
export type InstallCosmicCmsIntegrationMutationResult = ApolloReactCommon.MutationResult<InstallCosmicCmsIntegrationMutation>;
export type InstallCosmicCmsIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<InstallCosmicCmsIntegrationMutation, InstallCosmicCmsIntegrationMutationVariables>;
export const InstallShopifyCmsIntegrationDocument = gql`
    mutation installShopifyCmsIntegration($siteId: UUID!, $password: String!, $provision: Boolean) {
  installShopifyCmsIntegration(
    siteId: $siteId
    password: $password
    provision: $provision
  ) {
    success
    message
  }
}
    `;
export type InstallShopifyCmsIntegrationMutationFn = ApolloReactCommon.MutationFunction<InstallShopifyCmsIntegrationMutation, InstallShopifyCmsIntegrationMutationVariables>;

/**
 * __useInstallShopifyCmsIntegrationMutation__
 *
 * To run a mutation, you first call `useInstallShopifyCmsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallShopifyCmsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installShopifyCmsIntegrationMutation, { data, loading, error }] = useInstallShopifyCmsIntegrationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      password: // value for 'password'
 *      provision: // value for 'provision'
 *   },
 * });
 */
export function useInstallShopifyCmsIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InstallShopifyCmsIntegrationMutation, InstallShopifyCmsIntegrationMutationVariables>) {
        return ApolloReactHooks.useMutation<InstallShopifyCmsIntegrationMutation, InstallShopifyCmsIntegrationMutationVariables>(InstallShopifyCmsIntegrationDocument, baseOptions);
      }
export type InstallShopifyCmsIntegrationMutationHookResult = ReturnType<typeof useInstallShopifyCmsIntegrationMutation>;
export type InstallShopifyCmsIntegrationMutationResult = ApolloReactCommon.MutationResult<InstallShopifyCmsIntegrationMutation>;
export type InstallShopifyCmsIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<InstallShopifyCmsIntegrationMutation, InstallShopifyCmsIntegrationMutationVariables>;
export const AvailableContentfulOrganizationsForUserDocument = gql`
    query AvailableContentfulOrganizationsForUser($siteId: UUID!) {
  availableContentfulOrganizationsForUser(siteId: $siteId) {
    id
    name
    selected
    selectedSpace
    spaces {
      id
      name
      selected
    }
  }
}
    `;

/**
 * __useAvailableContentfulOrganizationsForUserQuery__
 *
 * To run a query within a React component, call `useAvailableContentfulOrganizationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableContentfulOrganizationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableContentfulOrganizationsForUserQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useAvailableContentfulOrganizationsForUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AvailableContentfulOrganizationsForUserQuery, AvailableContentfulOrganizationsForUserQueryVariables>) {
        return ApolloReactHooks.useQuery<AvailableContentfulOrganizationsForUserQuery, AvailableContentfulOrganizationsForUserQueryVariables>(AvailableContentfulOrganizationsForUserDocument, baseOptions);
      }
export function useAvailableContentfulOrganizationsForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableContentfulOrganizationsForUserQuery, AvailableContentfulOrganizationsForUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AvailableContentfulOrganizationsForUserQuery, AvailableContentfulOrganizationsForUserQueryVariables>(AvailableContentfulOrganizationsForUserDocument, baseOptions);
        }
export type AvailableContentfulOrganizationsForUserQueryHookResult = ReturnType<typeof useAvailableContentfulOrganizationsForUserQuery>;
export type AvailableContentfulOrganizationsForUserLazyQueryHookResult = ReturnType<typeof useAvailableContentfulOrganizationsForUserLazyQuery>;
export type AvailableContentfulOrganizationsForUserQueryResult = ApolloReactCommon.QueryResult<AvailableContentfulOrganizationsForUserQuery, AvailableContentfulOrganizationsForUserQueryVariables>;
export const CosmicCmsBucketsForIntegrationDocument = gql`
    query CosmicCMSBucketsForIntegration($siteId: UUID!) {
  cosmicCMSBucketsForIntegration(siteId: $siteId) {
    id
    name
    selected
  }
}
    `;

/**
 * __useCosmicCmsBucketsForIntegrationQuery__
 *
 * To run a query within a React component, call `useCosmicCmsBucketsForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCosmicCmsBucketsForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCosmicCmsBucketsForIntegrationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCosmicCmsBucketsForIntegrationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CosmicCmsBucketsForIntegrationQuery, CosmicCmsBucketsForIntegrationQueryVariables>) {
        return ApolloReactHooks.useQuery<CosmicCmsBucketsForIntegrationQuery, CosmicCmsBucketsForIntegrationQueryVariables>(CosmicCmsBucketsForIntegrationDocument, baseOptions);
      }
export function useCosmicCmsBucketsForIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CosmicCmsBucketsForIntegrationQuery, CosmicCmsBucketsForIntegrationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CosmicCmsBucketsForIntegrationQuery, CosmicCmsBucketsForIntegrationQueryVariables>(CosmicCmsBucketsForIntegrationDocument, baseOptions);
        }
export type CosmicCmsBucketsForIntegrationQueryHookResult = ReturnType<typeof useCosmicCmsBucketsForIntegrationQuery>;
export type CosmicCmsBucketsForIntegrationLazyQueryHookResult = ReturnType<typeof useCosmicCmsBucketsForIntegrationLazyQuery>;
export type CosmicCmsBucketsForIntegrationQueryResult = ApolloReactCommon.QueryResult<CosmicCmsBucketsForIntegrationQuery, CosmicCmsBucketsForIntegrationQueryVariables>;
export const DatoCmsProjectsForIntegrationDocument = gql`
    query DatoCMSProjectsForIntegration($siteId: UUID!) {
  datoCMSProjectsForIntegration(siteId: $siteId) {
    id
    name
    selected
  }
}
    `;

/**
 * __useDatoCmsProjectsForIntegrationQuery__
 *
 * To run a query within a React component, call `useDatoCmsProjectsForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatoCmsProjectsForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatoCmsProjectsForIntegrationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDatoCmsProjectsForIntegrationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DatoCmsProjectsForIntegrationQuery, DatoCmsProjectsForIntegrationQueryVariables>) {
        return ApolloReactHooks.useQuery<DatoCmsProjectsForIntegrationQuery, DatoCmsProjectsForIntegrationQueryVariables>(DatoCmsProjectsForIntegrationDocument, baseOptions);
      }
export function useDatoCmsProjectsForIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DatoCmsProjectsForIntegrationQuery, DatoCmsProjectsForIntegrationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<DatoCmsProjectsForIntegrationQuery, DatoCmsProjectsForIntegrationQueryVariables>(DatoCmsProjectsForIntegrationDocument, baseOptions);
        }
export type DatoCmsProjectsForIntegrationQueryHookResult = ReturnType<typeof useDatoCmsProjectsForIntegrationQuery>;
export type DatoCmsProjectsForIntegrationLazyQueryHookResult = ReturnType<typeof useDatoCmsProjectsForIntegrationLazyQuery>;
export type DatoCmsProjectsForIntegrationQueryResult = ApolloReactCommon.QueryResult<DatoCmsProjectsForIntegrationQuery, DatoCmsProjectsForIntegrationQueryVariables>;
export const SanityCmsProjectsForIntegrationDocument = gql`
    query SanityCMSProjectsForIntegration($siteId: UUID!) {
  sanityCMSProjectsForIntegration(siteId: $siteId) {
    id
    name
    selected
    selectedDataset
  }
}
    `;

/**
 * __useSanityCmsProjectsForIntegrationQuery__
 *
 * To run a query within a React component, call `useSanityCmsProjectsForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSanityCmsProjectsForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSanityCmsProjectsForIntegrationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSanityCmsProjectsForIntegrationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SanityCmsProjectsForIntegrationQuery, SanityCmsProjectsForIntegrationQueryVariables>) {
        return ApolloReactHooks.useQuery<SanityCmsProjectsForIntegrationQuery, SanityCmsProjectsForIntegrationQueryVariables>(SanityCmsProjectsForIntegrationDocument, baseOptions);
      }
export function useSanityCmsProjectsForIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SanityCmsProjectsForIntegrationQuery, SanityCmsProjectsForIntegrationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SanityCmsProjectsForIntegrationQuery, SanityCmsProjectsForIntegrationQueryVariables>(SanityCmsProjectsForIntegrationDocument, baseOptions);
        }
export type SanityCmsProjectsForIntegrationQueryHookResult = ReturnType<typeof useSanityCmsProjectsForIntegrationQuery>;
export type SanityCmsProjectsForIntegrationLazyQueryHookResult = ReturnType<typeof useSanityCmsProjectsForIntegrationLazyQuery>;
export type SanityCmsProjectsForIntegrationQueryResult = ApolloReactCommon.QueryResult<SanityCmsProjectsForIntegrationQuery, SanityCmsProjectsForIntegrationQueryVariables>;
export const SanityCmsDatasetsForIntegrationDocument = gql`
    query SanityCMSDatasetsForIntegration($siteId: UUID!, $projectId: String!) {
  sanityCMSDatasetsForIntegration(siteId: $siteId, projectId: $projectId) {
    name
    aclMode
  }
}
    `;

/**
 * __useSanityCmsDatasetsForIntegrationQuery__
 *
 * To run a query within a React component, call `useSanityCmsDatasetsForIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSanityCmsDatasetsForIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSanityCmsDatasetsForIntegrationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSanityCmsDatasetsForIntegrationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SanityCmsDatasetsForIntegrationQuery, SanityCmsDatasetsForIntegrationQueryVariables>) {
        return ApolloReactHooks.useQuery<SanityCmsDatasetsForIntegrationQuery, SanityCmsDatasetsForIntegrationQueryVariables>(SanityCmsDatasetsForIntegrationDocument, baseOptions);
      }
export function useSanityCmsDatasetsForIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SanityCmsDatasetsForIntegrationQuery, SanityCmsDatasetsForIntegrationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SanityCmsDatasetsForIntegrationQuery, SanityCmsDatasetsForIntegrationQueryVariables>(SanityCmsDatasetsForIntegrationDocument, baseOptions);
        }
export type SanityCmsDatasetsForIntegrationQueryHookResult = ReturnType<typeof useSanityCmsDatasetsForIntegrationQuery>;
export type SanityCmsDatasetsForIntegrationLazyQueryHookResult = ReturnType<typeof useSanityCmsDatasetsForIntegrationLazyQuery>;
export type SanityCmsDatasetsForIntegrationQueryResult = ApolloReactCommon.QueryResult<SanityCmsDatasetsForIntegrationQuery, SanityCmsDatasetsForIntegrationQueryVariables>;
export const DatoCmsAddedDocument = gql`
    subscription DatoCmsAdded($siteId: UUID!) {
  datoCmsIntegrationAdded(siteId: $siteId)
}
    `;

/**
 * __useDatoCmsAddedSubscription__
 *
 * To run a query within a React component, call `useDatoCmsAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDatoCmsAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatoCmsAddedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDatoCmsAddedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<DatoCmsAddedSubscription, DatoCmsAddedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<DatoCmsAddedSubscription, DatoCmsAddedSubscriptionVariables>(DatoCmsAddedDocument, baseOptions);
      }
export type DatoCmsAddedSubscriptionHookResult = ReturnType<typeof useDatoCmsAddedSubscription>;
export type DatoCmsAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<DatoCmsAddedSubscription>;
export const ContentfulAddedDocument = gql`
    subscription ContentfulAdded($siteId: UUID!) {
  contentfulIntegrationAdded(siteId: $siteId)
}
    `;

/**
 * __useContentfulAddedSubscription__
 *
 * To run a query within a React component, call `useContentfulAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContentfulAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentfulAddedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useContentfulAddedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ContentfulAddedSubscription, ContentfulAddedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ContentfulAddedSubscription, ContentfulAddedSubscriptionVariables>(ContentfulAddedDocument, baseOptions);
      }
export type ContentfulAddedSubscriptionHookResult = ReturnType<typeof useContentfulAddedSubscription>;
export type ContentfulAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<ContentfulAddedSubscription>;
export const SanityAddedDocument = gql`
    subscription SanityAdded($siteId: UUID!) {
  sanityIntegrationAdded(siteId: $siteId)
}
    `;

/**
 * __useSanityAddedSubscription__
 *
 * To run a query within a React component, call `useSanityAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSanityAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSanityAddedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSanityAddedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<SanityAddedSubscription, SanityAddedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<SanityAddedSubscription, SanityAddedSubscriptionVariables>(SanityAddedDocument, baseOptions);
      }
export type SanityAddedSubscriptionHookResult = ReturnType<typeof useSanityAddedSubscription>;
export type SanityAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<SanityAddedSubscription>;
